import React from 'react';
import { isEmpty } from 'lodash/fp';
import filterSuggestions from 'utils/filterSuggestions';
import { Icon } from 'ui';
import RemoteAutoComplete from 'components/shared/RemoteAutoComplete';
import Item from './Item';

const ContentMapping = _props => {
  const { suggestionsProps, ...props } = _props;
  const hasMappings = !isEmpty(props.mappings);
  return (
    <div>
      {props.editing && (
        <RemoteAutoComplete
          placeholder={props.placeholder}
          className="NewInput NewInput--light NewInput--fw mb-16"
          onSuggestionSelected={props.onCreateMapping}
          filterSuggestions={filterSuggestions(
            props.mappings,
            suggestionsProps.filterKey,
          )}
          {...suggestionsProps}
        />
      )}
      {hasMappings && (
        <div>
          {props.mappings.map(mapping => (
            <Item
              key={mapping.id}
              children={props.renderMapping(mapping)}
              onRemove={() => props.onRemoveMapping(mapping)}
              {...mapping}
              {...props}
            />
          ))}
        </div>
      )}
      {!hasMappings && !props.editing && (
        <button
          type="button"
          className="u-linkBtn fz-base fw-n"
          onClick={props.toggleEditing}
        >
          <Icon name="add" className="mr-4" />
          {props.addButtonText}
        </button>
      )}
      {!props.editing && props.viewAllRelatedUrls && (
        <a
          className="d-b mt-16 u-linkBtn"
          href={props.viewMappingsUrl}
          children={props.viewMappingsText}
        />
      )}
      {props.editing && (
        <div className="d-f jc-e ai-c mt-16">
          <button
            type="button"
            className="ml-16 NewButton NewButton--blue NewButton--wide NewButton--center"
            onClick={props.toggleEditing}
            children="Done"
          />
        </div>
      )}
    </div>
  );
};

export default ContentMapping;
